"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleSlide = exports.ToggleBtnContainer = exports.StyledIcon = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    right: 2px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 21px;\n  height: 21px;\n  top: 2px;\n  right: 51%;\n  border-radius: 100%;\n  background-color: white;\n  transition: all 0.3s ease;\n\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 50px;\n  height: 25px;\n  background: ", ";\n  border-radius: 30px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-block;\n  vertical-align: text-bottom;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-right: 11px;\n  width: ", ";\n  height: ", ";\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center center;\n  z-index: 3;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledIcon = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var width = _ref.width;
  return width || '8px';
}, function (_ref2) {
  var height = _ref2.height;
  return height || '8px';
});

exports.StyledIcon = StyledIcon;

var ToggleBtnContainer = _styledComponents["default"].div(_templateObject2(), function (_ref3) {
  var theme = _ref3.theme,
      toggled = _ref3.toggled;
  return toggled ? theme.colors.palette[7] : '#F3F4F5';
});

exports.ToggleBtnContainer = ToggleBtnContainer;

var ToggleSlide = _styledComponents["default"].div(_templateObject3(), function (_ref4) {
  var toggled = _ref4.toggled;
  return toggled && (0, _styledComponents.css)(_templateObject4());
});

exports.ToggleSlide = ToggleSlide;

//# sourceMappingURL=styled.js.map